import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import SymptomCheckService from '../../services/symptom-check.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-interview',
	templateUrl: './symptom-check-interview.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, FormsModule ]
})
export class SymptomCheckInterviewComponent implements OnInit {
	private symptomCheckService: SymptomCheckService = inject(SymptomCheckService);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() interview: any;
	@Output() interviewChange: EventEmitter<any> = new EventEmitter<any>();
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.evidence = [];
		this.vm.groupChoiceOptions = this.symptomCheckService.getGroupChoiceOptions();
		this.vm.groupChoiceIds = Object.keys(this.vm.groupChoiceOptions);
		
		this.vm.interview.evidence = this.vm.interview.evidence || [];
		this.vm.interview.currentSubStep = this.vm.interview.currentSubStep || 1;
		this.vm.question = this.vm.interview.diagnosis.question;
		
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		if (this.vm.params['type'] === 'pre-visit') {
			this.vm.preVisit = true;
		}
		
		this.vm.handleBack = this.handleBack;
		this.vm.handleSubmit = this.handleSubmit;
	};
	
	handleEvidenceChange() {
		var evidence: any = this.vm.interview.evidence.filter((evidence) => {
			return evidence.addedAtSubStep !== this.vm.interview.currentSubStep;
		});
		
		switch (this.vm.question.type) {
			case 'single':
			{
				evidence.push({
					addedAtStep: 6,
					addedAtSubStep: this.vm.interview.currentSubStep,
					choice_id: this.vm.evidence,
					id: this.vm.question.items[0].id,
				});
				break;
			}
			case 'group_single':
			{
				evidence.push({
					addedAtStep: 6,
					addedAtSubStep: this.vm.interview.currentSubStep,
					choice_id: 'present',
					id: this.vm.evidence,
				});
				break;
			}
			case 'group_multiple':
			{
				var ids: any = Object.keys(this.vm.evidence);
				ids.forEach((id) => {
					evidence.push({
						addedAtStep: 6,
						addedAtSubStep: this.vm.interview.currentSubStep,
						choice_id: this.vm.evidence[id],
						id: id,
					});
				});
				break;
			}
			default:
			return;
		}
		
		this.vm.interview.evidence = evidence;
		this.interviewChange.emit(this.vm.interview);
	}
	
	handleBack() {
		if (this.vm.isProcessing) return;
		this.vm.isProcessing = true;
		
		this.vm.submitted = false;
		this.vm.evidence = [];
		var interview: any = this.angularHelperService.copy(this.vm.interview);
		
		if (interview.currentSubStep > 1) {
			interview.evidence = interview.evidence.filter((evidence) => { return evidence.addedAtSubStep !== interview.stepId; });
			
			if (this.vm.preVisit) {
				interview.preVisit = true;
			}
			
			this.restService.saveDiagnosisRevert({ stepId: interview.stepId }, interview)
			.then((res) => {
				interview.diagnosis = res;
				interview.currentSubStep--;
				interview.stepId--;
				
				this.vm.interview = interview;
				this.interviewChange.emit(this.vm.interview);
				this.vm.question = res.question;
				this.vm.isProcessing = false;
			})
			.catch(console.error);
		} else {
			this.symptomCheckService.prevStep();
		}
	}
	
	handleSubmit(mainForm: any) {
		this.vm.submitted = true;
		if (this.vm.isProcessing || mainForm.invalid) {
			return;
		}
		if (this.vm.isProcessing) {
			return;
		}
		this.vm.isProcessing = true;
		this.handleEvidenceChange();
		
		this.vm.interview.stepId = this.vm.interview.currentSubStep;
		if (this.vm.preVisit) {
			this.vm.interview.preVisit = true;
		}
		
		this.vm.submitted = false;
		this.vm.evidence = [];
		
		this.restService.saveDiagnosis(this.vm.interview)
			.then((res) => {
				var interview: any = this.angularHelperService.copy(this.vm.interview);
				interview.diagnosis = res;

				if (interview.diagnosis.should_stop) {
					this.vm.interview = interview;
					this.interviewChange.emit(this.vm.interview);
					this.angularHelperService.createTimer(() => { this.symptomCheckService.nextStep(); });
					return;
				}

				interview.currentSubStep++;

				this.vm.question = res.question;
				this.vm.interview = interview;
				this.interviewChange.emit(this.vm.interview);
				this.vm.isProcessing = false;
			})
			.catch((err) => {
				console.error(err);
				this.vm.isProcessing = false;
			});
	}
	
}